import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getAllFormTemplates,
  deleteFormTemplate,
} from "../../redux/formTemplateSlice";
import AppBar from "../../common/AppBar";

const columnNames = ["Name", "Action"];

const FormTemplates = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { formTemplates, loading, error } = useSelector(
    (state) => state.formTemplates
  );
  const [visibleColumns, setVisibleColumns] = useState(columnNames);
  const [searchQuery, setSearchQuery] = useState("");

  // Fetch templates on mount
  useEffect(() => {
    dispatch(getAllFormTemplates({ limit: 10, offset: 0 }));
  }, [dispatch]);

  // Toggle column visibility
  const toggleColumn = (col) => {
    setVisibleColumns((prev) =>
      prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col]
    );
  };

  // Navigate to form template creation/edit page
  const handleEditClick = (template) => {
    navigate("/add-form-template", {
      state: { editMode: true, template },
    });
  };

  // Delete a form template
  const handleDeleteClick = (id) => {
    if (window.confirm("Are you sure you want to delete this template?")) {
      dispatch(deleteFormTemplate(id));
    }
  };

  return (
    <div>
      <AppBar title="Form Templates" buttons={[]} />
      <div className="search-header">
        <div className="filter-dropdown">
          <button className="filter-button">Filter</button>
          <div className="filter-menu">
            {columnNames.map((col) => (
              <label key={col}>
                <input
                  type="checkbox"
                  checked={visibleColumns.includes(col)}
                  onChange={() => toggleColumn(col)}
                />
                {col}
              </label>
            ))}
          </div>
        </div>

        <input
          type="text"
          placeholder="Search..."
          className="search-input"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />

        {searchQuery && (
          <button className="clear-button" onClick={() => setSearchQuery("")}>
            x
          </button>
        )}
      </div>

      <div className="button-container">
        <button
          className="appbar-button"
          onClick={() => navigate("/add-form-template")}
        >
          Create Form Template
        </button>
      </div>

      {loading && <p>Loading...</p>}
      {error && <p className="error">{error}</p>}

      <table className="table">
        <thead>
          <tr>
            {visibleColumns.map((col) => (
              <th key={col}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {formTemplates?.map((row) => (
            <tr key={row.id}>
              {visibleColumns.includes("Name") && <td>{row.form_name}</td>}
              {visibleColumns.includes("Action") && (
                <td className="action-buttons">
                  <button
                    className="edit-row"
                    onClick={() => handleEditClick(row)}
                  >
                    ✏️
                  </button>
                  <button
                    className="delete-row"
                    onClick={() => handleDeleteClick(row.id)}
                  >
                    🗑
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default FormTemplates;
